// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_o5-0";
export var discountCodeInput = "_o5-1";